import {Component, Input, ChangeDetectionStrategy} from '@angular/core';
import {AbstractControl} from '@angular/forms';

@Component({
    selector: 'app-form-error',
    templateUrl: './form-error.component.html',
    styleUrls: ['./form-error.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class FormErrorComponent{

    @Input() control: AbstractControl | null = null;
    @Input() invalidKey: string | null = null; // Can force the error message

  constructor() { }

}
